module.exports = __webpack_public_path__ + "teqbahn-assets/media/project_7.4262ea9f.png";